export interface EventColorSet {
  fontColor: string;
  backgroundColor: string;
  borderColor: string;
  separetorColor: string;
}

export const EVENT_COLORS: EventColorSet[] = [
  {
    fontColor: '#008489',
    backgroundColor: '#CCF2F4',
    borderColor: '#00C0C7',
    separetorColor: '#00C0C7',
  },
  {
    fontColor: '#975600',
    backgroundColor: '#FCE5C7',
    borderColor: '#F38A00',
    separetorColor: '#F38A00',
  },
  {
    fontColor: '#BB2D7C',
    backgroundColor: '#F9DDEC',
    borderColor: '#DA3490',
    separetorColor: '#DA3490',
  },
  {
    fontColor: '#1F66BC',
    backgroundColor: '#D4E6FB',
    borderColor: '#2780EB',
    separetorColor: '#2780EB',
  },
  {
    fontColor: '#705F01',
    backgroundColor: '#F7EFC0',
    borderColor: '#DFBF03',
    separetorColor: '#988202',
  },
  {
    fontColor: '#6F38B1',
    backgroundColor: '#E5DBF1',
    borderColor: '#6F38B1',
    separetorColor: '#6F38B1',
  },
  {
    fontColor: '#4A7128',
    backgroundColor: '#E6FAD4',
    borderColor: '#9BEC54',
    separetorColor: '#30974A',
  },
  {
    fontColor: '#20755A',
    backgroundColor: '#D4E8E2',
    borderColor: '#268D6C',
    separetorColor: '#268D6C',
  },
];

/**
 * Creates a color map for events based on their titles
 */
export class EventColorMapper {
  private colorMap = new Map<string, EventColorSet>();
  private currentColorIndex = 0;

  getColorForEvent(title: string): EventColorSet {
    if (!this.colorMap.has(title)) {
      const color = EVENT_COLORS[this.currentColorIndex % EVENT_COLORS.length];
      this.colorMap.set(title, color);
      this.currentColorIndex++;
    }
    return this.colorMap.get(title)!;
  }

  reset(): void {
    this.colorMap.clear();
    this.currentColorIndex = 0;
  }
}
